import React, {FunctionComponent} from "react"
import {useNavigate} from "react-router"

interface RowProps {
	value?: any
	customClass: any
	url?: string
}

const Row: FunctionComponent<RowProps> = ({customClass, value, url}) => {
	const navigate = useNavigate()
	const sortRowClass = (classname: string, custom: string | null) => {
		let cname = classname
		if (url) cname = cname + "--url"
		if (custom) return cname + " " + custom
		else return cname
	}

	const handleClick = () => {
		if (url) navigate(url)
	}

	return (
		<td className={sortRowClass("table-row-data", customClass)} onClick={handleClick}>
			{value}
		</td>
	)
}

export default Row
